import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2, ViewChild, ElementRef, HostListener, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, NavigationExtras } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { LanguageService } from '../_services/language.service';
import { Subscription, of, interval } from 'rxjs';
import * as data from '../../assets/i18n/en.json';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '../_services/api.service';
import { ChatServiceService } from '../_services/chatService.service';
import {EnvironmentService} from "../_services/environment.service";

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  @ViewChild('toggleButton') toggleButton: any;
  @ViewChild('navbar') menu: any;
  @ViewChild('nav') elementView: ElementRef;

  toggleHome: boolean = true;
  toggleBusiness: boolean = true;
  toggleExemptions: boolean = true;
  toggleTax: boolean = true;
  toggleExclusions: boolean = true;
  isCollapsed = true;
  lang;
  path: string = "";
  environmentVal: string = '';
  url: string = "";
  viewHeight: number;
  message: string;
  subscription: Subscription;
  htmlComp = document.getElementsByTagName("html")[0];
  baseNumber = 100;
  userId: string = "";
  userName: string = "";
  loggedIn: boolean = false;

  languages: Language[] = [
    {
      name: 'English',
      code: 'en'
    },
    {
      name: 'Pilipino',
      code: 'tl'
    },
    {
      name: 'Español',
      code: 'es'
    },
    {
      name: '한국어',
      code: 'ko'
    },
    {
      name: 'Tiếng Việt',
      code: 'vi'
    },
    {
      name: 'հայերեն',
      code: 'hy'
    },
    {
      name: '简体中文',
      code: 'zh-CN'
    },
    {
      name: '繁體中文',
      code: 'zh-TW'
    },
    {
      name: 'हिन्दी',
      code: 'hi'
    },
    {
      name: '日本語',
      code: 'ja'
    },
    {
      name: 'ភាសាខ្មែរ',
      code: 'km'
    },
    {
      name: 'ไทย',
      code: 'th'
    },
    {
      name: 'ဗမာ',
      code: 'my'
    },
    {
      name: 'ગુજરાતી',
      code: 'gu'
    },
    {
      name: 'Indonesia',
      code: 'id'
    },
    {
      name: 'తెలుగు',
      code: 'te'
    },
    {
      name: 'Deutsch',
      code: 'de'
    }
  ]
  counter = 1;
  currentLang: Language = this.languages[this.counter]


  @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    this.viewHeight = this.elementView.nativeElement.offsetHeight;
  }

  constructor(private translateService: TranslateService, private http: HttpClient, private renderer: Renderer2,
                private titleService: Title, private router: Router, private activatedRoute: ActivatedRoute,
                private languageService: LanguageService, private el: ElementRef, private apiService: ApiService, public chatService: ChatServiceService,
              protected envService: EnvironmentService) {

    this.getHeaders();
    this.url = window.location.origin
    this.environmentVal = apiService.getEnvironment();

    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('lang') || 'en');
    const source = interval(4000);

    this.subscription = source.subscribe(val => this.changeLangValue());

    this.renderer.listen('window', 'click',(e:Event)=>{

     if(e.target !== this.toggleButton?.nativeElement && e.target!==this.menu?.nativeElement){

         this.isCollapsed=true;
      }
    });
    let test2;
    let test =Object.keys(data).map((key)=>{
      let temp = data[key]
      test2 =Object.keys(temp).map((rs) => {

        return temp[rs]
      })
      return data[key]
    });

  }

  changeLangValue() {

    if(this.counter > this.languages.length - 2)
      this.counter = 1
    else
      ++this.counter;
    this.currentLang = this.languages[this.counter]
  }
  stopPropagation(event: any) {
    let width = this.elementView.nativeElement.offsetWidth;
    console.log(width)
    if(width < 780) {
      event.stopPropagation();
    }

  }

  clicked(){
    this.isCollapsed = !this.isCollapsed;
    console.log(this.isCollapsed)
  }
  ngOnInit(): void {
    this.lang = localStorage.getItem('lang') || 'en';
    this.languageService.changeMessage(this.lang)
    const myHeaders = new Headers();

    const appTitle = this.titleService.getTitle();

    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {

          let child = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }
          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      ).subscribe((ttl: string) => {


        if(ttl.length === 0)
          this.titleService.setTitle('Assessor');
        else
          this.titleService.setTitle('Assessor - ' + ttl);
      });

      this.router.events.subscribe(event => {
        if(event instanceof NavigationEnd){
          this.path = event.urlAfterRedirects;

         }
      }
    )


  }

  upFont() {
    this.baseNumber += 5;
    this.htmlComp.style.fontSize = this.baseNumber.toString() + '%';

  }

  downFont(){
    this.baseNumber -= 5;
    this.htmlComp.style.fontSize = this.baseNumber.toString() + '%';

  }

  changeLang(lang, event: any) {
    console.log(event)
    event.close();
    localStorage.setItem('lang', lang);
    // window.location.reload();
    this.translateService.use(lang);
    console.log('changeLange'  + lang)
    this.languageService.changeMessage(lang)
  }

  item(event: any) {
    console.log(event);
  }

  getHeaders() {
    this.apiService.eFile().subscribe(data => {

      if(data.status == 200) {
        this.loggedIn = true;
        this.userId = data.body[0].value;
        this.userName = data.body[1].value + ", " + data.body[2].value;
      }

     })
  }

  login() {

    let fullPath = this.path
    const queryParams = { returnUrl: fullPath};

    this.router.navigate(['/login'], { queryParams }).then(() => {
      window.location.reload();
    });

  }



}

export interface Language {
  name: string;
  code: string;
}
